export const meetingDetailsQueryKeys = {
	meetingAgendaItems: (meetingId: string) => ["get-meeting-agenda-items-by-meeting", meetingId] as const,
	meetingActionItems: (meetingId: string) => ["get-meeting-action-items-by-meeting", meetingId] as const,
} as const;
